import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import {
  MatDialog as MatDialog,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CustomDateAdapter } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-adapter';
import { Workshop } from '../../../../../models/workshop';
import { WorkshopsComponent } from '../../workshops.component';
import { CUSTOM_DATE_FORMATS } from './custom-date-picker-header/custom-date-formats';
import { CustomDatePickerHeader } from './custom-date-picker-header/custom-date-picker-header';
import { dealerBlocked } from 'src/services/api-services/api-interfaces/dealerBlockedServices.interface';
import { APIDealerBlockedServices } from 'src/services/api-services/api-dealer-blocked-services';
import { ServiceSchedule } from 'src/services/api-services/api-interfaces/api-interface-service-schedule';
import { APIService } from 'src/services/api-services/api-service';
import { typeOfService } from 'src/services/api-services/api-interfaces/typeOfService.interface';
import { finalize, Observable, tap } from 'rxjs';
import { ThisReceiver } from '@angular/compiler';
import { APIServiceDealer } from 'src/services/api-services/api-service-dealer';

import { FormBuilder, Validators } from '@angular/forms';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { brands } from 'src/services/api-services/api-interfaces/brands.interface';

import moment from 'moment';
import { deleteLockSettingsDialog } from './delete-lock-settings/delete-lock-settings.dialog';
import { HelperService } from 'src/services/helperService';

import { TranslateService } from '@ngx-translate/core';
import { APIBlockedReason } from 'src/services/api-services/api-blocked-reason';

@Component({
    selector: 'app-lock-settings',
    templateUrl: './lock-settings.dialog.html',
    styleUrls: ['./lock-settings.dialog.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    ],
    standalone: false
})
export class LockSettingsDialog {

  customDatePickerHeader = CustomDatePickerHeader;

  constructor(
    private _formBuilder: FormBuilder,
    public brandsService: APIBrandsService,
    public dialogRef: MatDialogRef<WorkshopsComponent>,
    @Inject(MAT_DIALOG_DATA) public workshop: Workshop,
    public dialog: MatDialog,
    public dealerBlockedService: APIDealerBlockedServices,
    public Service: APIService,
    public ServiceDealer: APIServiceDealer,
    public helperService: HelperService,

    private translate: TranslateService,
    public lockedReasonService: APIBlockedReason
  ) {

  }

  ngOnInit(): void {
    this.blockDay = true;
    this.blockHours = false;
    this.StartDate = this.calendarTime;
    this.EndDate = this.calendarTime;
    this.StartHour = '1:00 AM';
    this.hourFinal = '11:30 PM';
    this.IntervalHours();

    this.diasSeleccionado = this.calendarTime.getDate();
  }
  initialpage: boolean = true;
  pagingTypeLocks: string = '';
  loadBloqued: boolean = true;
  isHistoryLoading: boolean = false;
  serviceDealer: any;
  brands: any[] = [];
  IsLoading: boolean = true;
  refreshLoader: boolean = false;
  checkCopiBrandBloqued: boolean = false;
  serviceAll: any[] = [];
  blockDay: boolean = true;
  blockHours: boolean = false;
  diasSeleccionado: any;
  BrandIdFilter: number = 0;
  BrandIdInitial: number | undefined = 0;
  apoiments: any[] = [];
  service: any[] = [];
  indexBrands: number = 0;
  public historialLocks: any[] = [];
  typeOfServiceCopy: boolean = false;
  public DataLocks: any[] = [];
  fechas: any[] = [];
  services: typeOfService[] = [];
  IdbloquingReason: any = '';
  public calendarTime: Date = new Date();
  public StartDate: any = '';
  public EndDate: any = '';
  public StartHour: any = '1:00 AM';
  public hourFinal: any = '11:30 PM';
  serviceCorrectSave: string[] = [];
  serviceIncorrectSave: string[] = [];
  CanEditData: boolean = false;
  LockData: any = [];
  dataLocksInt: dealerBlocked = {
    description: '',
    dayOfWeek: '',
    hourInitial: '',
    hourFinal: '',
    isActive: false,
    blockedServiceWorkshopId: 1,
    initialDate: new Date(''),
    finalDate: new Date(''),
    optional: '',
    serviceWorkshopId: 1,
  };

  style1 = {
    background: '#16BAE7',
    border: 'solid 1px #16BAE7',
    color: '#fff',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };
  style2 = {
    background: '#fff ',
    border: 'solid 1px #16BAE7',
    color: '#16BAE7',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };

  style3 = {
    background: '#EBEEF2',
    border: 'solid 1px #EBEEF2 ',
    color: '#fff',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };
  style4 = {
    background: '#fff ',
    border: 'solid 1px #EBEEF2 ',
    color: '#EBEEF2',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };
  timehours: any = [];
  reasonWorkshops: any = [];

  // Funtios get for info data base
  getServiceBrand() {
    this.brandsService
      ?.getBrandWorkshop(this.workshop.workshopId)
      .pipe(
        tap((response) => {
          if (!response.message) {
            this.brands = response;
            this.brands[0].style = this.style1;
            this.BrandIdFilter = this.brands[0].brandId;
            this.BrandIdInitial = this.brands[0].brandId;
          }
        }),
        finalize(() => this.getDealerBlockedReason())
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  getserviceWorkshopId() {
    if (this.BrandIdFilter !== this.BrandIdInitial) {
      this.service = [
        ...this.serviceAll.filter(
          (response) => response.brandId === this.BrandIdFilter
        ),
      ];
      this.FilterDataLockForBrand();
    } else {
      this.Service?.getworkshopAndbrand(this.workshop.workshopId)
        .pipe(
          tap((response) => {
            if (!response.message) {
              this.serviceAll = response.filter(
                (response) => response.isActive === true
              );
              this.service = [
                ...this.serviceAll.filter(
                  (response) => response.brandId === this.BrandIdFilter
                ),
              ];
            }
          }),
          finalize(() => this.SelectDateIntCalendar())
        )
        .subscribe({
          error: (error) => {
            // Validation 401 error
            if(error.status === 401){
              this.helperService.logoutToken()
            }
          }
        });
    }
  }

  getDealerBlockedServicesHistorial() {
    this.isHistoryLoading = true;
    this.historialLocks = [];

    this.dealerBlockedService
      .getworkshopHistorialLocks(this.workshop.workshopId)
      .pipe(
        tap((response) => {
          if (!response.message) {
            this.historialLocks = this.formatHistory(response);
          }
        }),
        finalize(() => (this.isHistoryLoading = false))
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  getDealerBlockedReason() {
    if (this.BrandIdFilter !== this.BrandIdInitial) {
      this.getserviceWorkshopId();
    } else {
      this.lockedReasonService
        .getByreasonworkshop()
        .pipe(
          tap((response) => {
            if (!response.message) {
              this.reasonWorkshops = response;
            }
          }),
          finalize(() => this.getserviceWorkshopId())
        )
        .subscribe({
          error: (error) => {
            // Validation 401 error
            if(error.status === 401){
              this.helperService.logoutToken()
            }
          }
        });
    }
  }
  // Funtion Filter For brand
  onApplyFilter(brand: any) {
    // this.loadBloqued = false;
    if (brand.brandId) {
      this.BrandIdInitial = undefined;
      this.BrandIdFilter = brand.brandId;
    }

    this.getserviceWorkshopId();
  }

  ChangeTypeofservice() {
    // (change) delivers the new value; legacy (click) saw the old one: checking turns every service on
    this.serviceAll.map((service) => (service.isActive = this.typeOfServiceCopy));
  }

  FilterDataLockForBrand() {
    this.loadBloqued = true;

    this.SelectDateIntCalendar();
  }

  //  Metods config hours
  dateFilter = (date): boolean => {
    let hoy = new Date();
    let miliseg = 24 * 60 * 60 * 1000;

    if (date >= new Date(hoy.getTime() - miliseg)) {
      return true;
    } else {
      return false;
    }
  };

  dateFilterEnd = (date): boolean => {
    if (date >= this.StartDate) {
      return true;
    } else {
      return false;
    }
  };
  ChangeDateEnd() {
    if (this.StartDate > this.EndDate) {
      this.EndDate = this.StartDate;
    }
  }

  // Funtions Show data
  IntervalHours() {
    let interval = moment.duration('00:15:00').asHours();
    const hourNumArr = moment.duration('01:00:00').asHours();
    const hourNumArrF = moment.duration('23:45:00').asHours();
    this.timehours = [];
    for (let i = hourNumArr; i < hourNumArrF; i += interval) {
      let time =
        ('0' + (Math.floor(i) % 24)).slice(-2) +
        ':' +
        ((i % 1) * 60 + '0').slice(0, 2);
      let amFormat = moment(time, 'HH:mm:ss').format('h:mm A');
      let hoursSplit = amFormat.split(' ');
      let replaceHours = hoursSplit[1].replace(
        hoursSplit[1],
        `${hoursSplit[0]} ${hoursSplit[1][0]}${hoursSplit[1][1]}`
      );
      this.timehours.push(replaceHours);
      this.timehours = [...new Set(this.timehours)];
    }
  }

  ButtonTypeconfigOrHistorial(tipe) {
    this.pagingTypeLocks = tipe;
    this.initialpage = false;
    this.loadBloqued = false;
    if (tipe === 'blocks') this.getServiceBrand();
    if (tipe === 'historial') this.getDealerBlockedServicesHistorial();
  }
  ChangeTypeBlock(StateBlock: boolean, TypeBlock: string) {
    // change state blocks in all day and hours
    if (StateBlock === false) {
      this.StartHour = '1:00 AM';
      this.hourFinal = '11:30 PM';
      this.blockDay = false;
    } else {
      this.StartHour = '1:00 AM';
      this.hourFinal = '11:30 PM';
      this.blockDay = true;
    }
  }

  onIconMouseHoverAndOut(
    elementId: string,
    className: string,
    isFill: boolean
  ) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }
  private formatHistory(history: any[]): any[] {
    return history.map((lock) => ({
      ...lock,
      serviceNamesArray: lock.serviceName
        ? lock.serviceName.split(',').map((service) => service.trim())
        : [],
      initialDateBlockedServices: moment(
        lock.initialDateBlockedServices
      ).format('DD/MM/YYYY'),
      finalDateBlockedServices: moment(lock.finalDateBlockedServices).format(
        'DD/MM/YYYY'
      ),
      hourInitialBlockedServices: moment(
        lock.hourInitialBlockedServices,
        'HH:mm:ss'
      ).format('h:mm A'),
      hourFinaBlockedServices: moment(
        lock.hourFinaBlockedServices,
        'HH:mm:ss'
      ).format('h:mm A'),
    }));
  }
  ValidationOfCorrectHours(): boolean {
    let hour = moment(this.StartHour, 'h:mm A').format('HH:mm:ss');
    let split = hour.split(':');
    let hour_inicial_validacion = Number(split[0] + split[1]);
    hour = moment(this.hourFinal, 'h:mm A').format('HH:mm:ss');
    split = hour.split(':');
    let hour_final_validacion = Number(split[0] + split[1]);
    let isvisible = true;
    if (hour_inicial_validacion < hour_final_validacion) {
      //if any filter is filled the button will be enabled
      isvisible = false;
    }
    return isvisible;
  }
  issaveDisabled(): boolean {
    // function to enable clear button conditionally
    let hour = moment(this.StartHour, 'h:mm A').format('HH:mm:ss');
    let split = hour.split(':');
    let hour_inicial_validacion = Number(split[0] + split[1]);
    (hour = moment(this.hourFinal, 'h:mm A').format('HH:mm:ss')),
      (split = hour.split(':'));
    let hour_final_validacion = Number(split[0] + split[1]);
    let isDisabled = true;
    if (
      this.StartDate !== '' &&
      this.EndDate !== '' &&
      hour_inicial_validacion < hour_final_validacion &&
      this.service.filter((service) => service.isActive === true).length > 0 &&
      this.IdbloquingReason !== ''
    ) {
      //if any filter is filled the button will be enabled
      isDisabled = false;
    }
    return isDisabled;
  }
  // Funtions for show data correct in the calendar

  SelectDateIntCalendar() {
    this.CanEditData = false;
    this.LockData = [];
    this.service.forEach((service) => {
      service.isActive = false;
    });
    this.loadBloqued = true;

    let content2: HTMLElement = document.getElementById(
      'activarOrdenes'
    ) as HTMLElement;
    content2.click();
  }
  review_date(LockSelect: any) {
    let DateStart = LockSelect.initialDate;
    let DateEnd = LockSelect.finalDate;
    if (DateStart !== DateEnd) {
      DateStart = DateStart.toString().split('/');
      DateEnd = DateEnd.toString().split('/');
      for (let i = Number(DateStart[0]) + 1; i < Number(DateEnd[0]); i++) {
        let valided = this.DataLocks.filter(
          (s) => s.optional === i + '/' + DateStart[1] + '/' + DateStart[2]
        );
        if (valided.length === 0) {
          this.DataLocks[this.DataLocks.length] = {
            description: LockSelect.description,
            dayOfWeek: LockSelect.dayOfWeek,
            hourInitial: LockSelect.hourInitial,
            hourFinal: LockSelect.hourFinal,
            isActive: LockSelect.isActive,
            blockedserviceWorkshopId: LockSelect.blockedserviceWorkshopId,
            initialDate: LockSelect.initialDate,
            finalDate: LockSelect.finalDate,
            optional: i + '/' + DateStart[1] + '/' + DateStart[2],
            blockedServiceWorkshopId: LockSelect.blockedServiceWorkshopId,
          };
        }
      }
    }
  }
  reviewdata(date: Date) {
    let LockData: any = [];
    LockData = this.DataLocks.filter(
      (s) =>
        s.initialDate === date.toLocaleDateString() && s.optional === undefined
    );
    LockData.forEach((LocksDatesSelect) => {
      this.review_date(LocksDatesSelect);
    });
  }

  public isMeeting(date: Date) {
    if (this.DataLocks.length !== 0) {
      this.reviewdata(date);
      let InitialDateFilter = this.DataLocks.map((s) => s.initialDate);
      let FinalDateFilter = this.DataLocks.map((s) => s.finalDate);
      let OptionalDateFilter = this.DataLocks.map((s) => s.optional);

      InitialDateFilter = InitialDateFilter.filter(
        (s) => s === date.toLocaleDateString()
      );
      FinalDateFilter = FinalDateFilter.filter(
        (s) => s === date.toLocaleDateString()
      );
      OptionalDateFilter = OptionalDateFilter.filter(
        (s) => s === date.toLocaleDateString()
      );
      if (
        InitialDateFilter.length !== 0 ||
        FinalDateFilter.length !== 0 ||
        OptionalDateFilter.length !== 0
      ) {
        return true ? 'meeting' : '';
      } else {
        return false ? 'meeting' : '';
      }
    } else {
      return false ? 'meeting' : '';
    }
  }

  // Funtions save and edit
  onsave(): void {
    this.loadBloqued = false;
    let date = this.StartDate.toLocaleDateString();
    let date_end = this.EndDate.toLocaleDateString();

    if (!this.checkCopiBrandBloqued) {
      this.service.forEach((service) => {
        if (service.isActive === true && this.CanEditData === false) {
          this.post_put(
            this.LockData[0],
            1,
            Number(service.serviceWorkshopId),
            service.isActive,
            service.serviceName
          );
        } else {
          if (
            this.LockData.blockedServiceWorkshopId !== undefined &&
            service.isActive === this.LockData.isActive &&
            service.serviceWorkshopId === this.LockData.serviceWorkshopId
          ) {
            this.post_put(
              this.LockData,
              0,
              Number(service.serviceWorkshopId),
              service.isActive,
              service.serviceName
            );
          } else if (
            this.LockData.blockedServiceWorkshopId === undefined &&
            service.isActive === true
          ) {
            this.post_put(
              this.LockData,
              1,
              Number(service.serviceWorkshopId),
              service.isActive,
              service.serviceName
            );
          }
        }
      });
    } else {
      let servicesActive = [...this.service];
      servicesActive.forEach((serviceActive, i) => {
        let serviceAllFilter = [
          ...this.serviceAll.filter(
            (s) => s.serviceId === serviceActive.serviceId
          ),
        ];
        for (let j = 0; j < serviceAllFilter.length; j++) {
          if (this.service[i].isActive === true && this.CanEditData === false) {
            this.post_put(
              this.LockData[this.LockData.length - 1],
              1,
              Number(serviceAllFilter[j].serviceWorkshopId),
              this.service[i].isActive,
              this.service[i].serviceName
            );
          } else {
            if (
              this.LockData.blockedServiceWorkshopId !== undefined &&
              this.service[i].isActive === this.LockData.isActive &&
              this.service[i].serviceWorkshopId ===
                this.LockData.serviceWorkshopId
            ) {
              this.post_put(
                this.LockData,
                0,
                Number(serviceAllFilter[j].serviceWorkshopId),
                this.service[i].isActive,
                this.service[i].serviceName
              );
            } else if (
              this.LockData.blockedServiceWorkshopId === undefined &&
              this.service[i].isActive === true
            ) {
              this.post_put(
                this.LockData,
                1,
                Number(serviceAllFilter[j].serviceWorkshopId),
                this.service[i].isActive,
                this.service[i].serviceName
              );
            }
          }
        }
      });
    }

    setTimeout(() => {
      if (this.serviceCorrectSave.length > 0) {
        const translateText = this.translate.instant('ToastBlockWorkshop');

        this.helperService.showAlert =true
        this.helperService.typeAlert ="success"
        this.helperService.messageAlert =translateText

        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)
      }

      if (this.serviceIncorrectSave.length > 0) {
        const translateText = this.translate.instant(
          'ToastBlockAdvisorDontSave',
          {
            service: [...new Set(this.serviceIncorrectSave)],
          }

        );
        this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =translateText

        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)


      }
      this.dialogRef.close();
    }, 2000);
  }
  onCancel(): void {
    this.dialogRef.close();
  }

  post_put(
    service: any,
    mode: number,
    serviceid: number,
    isActive: boolean,
    serviceName: string
  ) {
    if (mode === 0) {
      let DataLocksInt = {
        description: 'Bloqued',
        dayOfWeek: 'Blo',
        hourInitial: moment(this.StartHour, 'h:mm A').format('HH:mm:ss'),
        hourFinal: moment(this.hourFinal, 'h:mm A').format('HH:mm:ss'),
        isActive: isActive,
        blockedServiceWorkshopId: service.map(
          (s) => s.blockedServiceWorkshopId
        )[0],
        initialDate: moment(this.StartDate).format('YYYY-MM-DD'),
        finalDate: moment(this.EndDate).format('YYYY-MM-DD'),
        optional: undefined,
        serviceWorkshopId: serviceid,
        blockedReasonId: this.IdbloquingReason,
      };
      this.dealerBlockedService.put(DataLocksInt).subscribe();
    } else if (mode === 1) {
      let DataLocksInt = {
        description: 'Bloqued',
        dayOfWeek: 'Blo',
        hourInitial: moment(this.StartHour, 'h:mm A').format('HH:mm:ss'),
        hourFinal: moment(this.hourFinal, 'h:mm A').format('HH:mm:ss'),
        isActive: isActive,
        blockedServiceWorkshopId: 0,
        initialDate: moment(this.StartDate).format('YYYY-MM-DD'),
        finalDate: moment(this.EndDate).format('YYYY-MM-DD'),
        optional: undefined,
        serviceWorkshopId: serviceid,
        blockedReasonId: this.IdbloquingReason,
      };

      this.dealerBlockedService
        .post(DataLocksInt)
        .pipe(
          tap((response) => {
            if (response.message) {
              this.serviceIncorrectSave.push(
                this.translate.instant(serviceName)
              );
            } else {
              this.serviceCorrectSave.push(this.translate.instant(serviceName));
            }
          })
        )
        .subscribe({
          error: (failed) => {
            // Validation 401 error
            if(failed.status === 401){
              this.helperService.logoutToken()
            }

            console.log(failed);

            this.serviceIncorrectSave.push(this.translate.instant(serviceName));
          },
        });
    }
  }

  // Funtions Historial locks

  EditLookSetting(lockSelected) {
    let date = lockSelected.initialDate.split('/');
    this.calendarTime = new Date(date[1] + '/' + date[0] + '/' + date[2]);
    this.StartDate = new Date(date[1] + '/' + date[0] + '/' + date[2]);
    date = lockSelected.finalDate.split('/');
    this.EndDate = new Date(date[1] + '/' + date[0] + '/' + date[2]);
    this.LockData = lockSelected;
    // this.pagingTypeLocks = false;
    this.CanEditData = true;
    this.StartHour = lockSelected.hourInitial;
    this.hourFinal = lockSelected.hourFinal;
    if (this.StartHour === '1:00 AM' && this.hourFinal === '11:30 PM') {
      this.blockDay = true;
      this.blockHours = false;
    } else {
      this.blockDay = false;
      this.blockHours = true;
    }

    for (let j = 0; j < this.service.length; j++) {
      if (
        lockSelected.serviceWorkshopId === this.service[j].serviceWorkshopId
      ) {
        this.service[j].isActive = lockSelected.isActive;
      }
    }
  }
  onDeleteWorkshopClick(lockSelected) {
    console.log(lockSelected);
    this.dialogRef.close();
    lockSelected.workshopId = this.workshop.workshopId;
    lockSelected.workshopName = this.workshop.workshopName;
    lockSelected.initialDate = moment(
      lockSelected.initialDateBlockedServices,
      'DD/MM/YYYY'
    ).format('YYYY-MM-DD');
    lockSelected.finalDate = moment(
      lockSelected.finalDateBlockedServices,
      'DD/MM/YYYY'
    ).format('YYYY-MM-DD');
    lockSelected.hourInitial = moment(
      lockSelected.hourInitialBlockedServices,
      'h:mm A'
    ).format('HH:mm:ss');
    lockSelected.hourFinal = moment(
      lockSelected.hourFinaBlockedServices,
      'h:mm A'
    ).format('HH:mm:ss');
    const dialogRef = this.dialog.open(deleteLockSettingsDialog, {
      width: '600px',
      panelClass: 'icon-outside',
      data: lockSelected,
    });
  }
}
